<template>
  <div>
    <el-table @selection-change="selectChange" ref="childDeviceTable" :data="deviceInfo" :max-height="tableHeight"
              style="width: 100%" border>
      <template v-for="item in tableColumns">
        <el-table-column :key="item.field" type="selection" v-if="item.field === 'checkBox'"></el-table-column>
        <el-table-column :key="item.field" :prop="item.field" :label="item.title"
                         :align="item.align"
                         v-else-if="item.field === 'name' && item.isShow">
          <template v-slot="scope">
            <div style="text-align: center;">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column :key="item.field" :prop="item.field" :label="item.title" :width=item.width
                         :align="item.align"
                         v-else-if="item.field === 'status' && item.isShow">
          <template v-slot="scope">
            <div :class="scope.row.status === 0 ? 'green' : 'red'"
                 class="dotStatus"></div>
          </template>
        </el-table-column>
        <el-table-column :key="item.field" :prop="item.field" :label="item.title"
                         :align="item.align"
                         v-else-if="item.field === 'typeCnName' && item.isShow">
          <template v-slot="scope">
            <div>
              {{ scope.row.typeCnName }}/{{ scope.row.brandCnName }}/{{ scope.row.modelCnName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :key="item.field" :prop="item.field" :label="item.title"
                         :align="item.align"
                         v-else-if="item.field === 'note' && item.isShow">
          <template v-slot="scope">
            <div>
              {{ scope.row.note ? scope.row.note : '--' }}
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column align="center" label="操作" min-width="140">
        <template v-slot="scope">
          <b-button variant="text" style="color: rgba(7, 230, 248, 1)"
                    @touchstart="() => showDialog('查看测点','ShowList',false,'40vw','point',scope.row)"
                    @click="() => showDialog('查看测点','ShowList',false,'40vw','point',scope.row)">
            <span style="margin-left: 4px;">查看测点</span>
          </b-button>
          <b-button variant="text" style="color: rgba(7, 230, 248, 1)"
                    @touchstart="() => showThresholdDialog('告警阈值','ThresholdValueList',false,'90vw','point',scope.row)"
                    @click="() => showThresholdDialog('告警阈值','ThresholdValueList',false,'90vw','point',scope.row)">
            <span style="margin-left: 4px;">告警阈值</span>
          </b-button>
          <b-button variant="text" style="color: #299FFB"
                    @touchstart="() => showDialog('编辑设备','Modify',true,'40vw','device',scope.row)"
                    @click="() => showDialog('编辑设备','Modify',true,'40vw','device',scope.row)">
            <span style="margin-left: 4px;">编辑设备</span>
          </b-button>
          <el-popover popper-class="popoverClass"
                      placement="bottom"
                      trigger="hover"
                      width="400">
            <b-button slot="reference" variant="text" style="color: #fb2929">
              <span style="margin-left: 4px;">更多...</span>
            </b-button>
            <b-button variant="text" style="color: rgba(7, 230, 248, 1)"
                      @touchstart="() => showDialog('查看功能','ShowControlList',false,'40vw','control',scope.row)"
                      @click="() => showDialog('查看功能','ShowControlList',false,'40vw','control',scope.row)">
              <span style="margin-left: 4px;">查看功能</span>
            </b-button>
            <b-button variant="text" style="color: #299FFB"
                      @touchstart="() => showDialog('修改空间','BelongsModify',true,'40vw','belongs',scope.row)"
                      @click="() => showDialog('修改空间','BelongsModify',true,'40vw','belongs',scope.row)">
              <span style="margin-left: 4px;">修改空间</span>
            </b-button>
            <b-button variant="text" style="color: #299FFB"
                      @touchstart="() => showDialog('可视化编辑','VisualEdit',true,'50vw','visual',scope.row)"
                      @click="() => showDialog('可视化编辑','VisualEdit',true,'50vw','visual',scope.row)">
              <span style="margin-left: 4px;">可视化编辑</span>
            </b-button>
            <b-button variant="text" style="color: #fb2929" @touchstart="() => deleteDevice(scope.row)" @click="deleteDevice(scope.row)">
              <span style="margin-left: 4px;">解除绑定</span>
            </b-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <function-dialog-component
      :dialog-title="dialogTitle"
      :dialogVisible.sync="dialogVisible"
      :width="width"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="min-height: 40vh;">
        <component :is="component" ref="functionDialogComponent" :deviceInfo="deviceInfo" :dialogData="dialogData"
                   :form="form"
                   :spaceInfoId="spaceInfoId" :spaceValue="spaceValue" @receiveData="receive"></component>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;" v-if="showFooter">
        <el-button @touchstart="() => {this.dialogVisible = false}" @click="() => {this.dialogVisible = false}" size="mini">关 闭</el-button>
        <el-button @touchstart="saveData" @click="saveData" type="primary" size="mini">保 存</el-button>
      </div>
    </function-dialog-component>
    <!--      告警阈值-->
    <dialog-component
      :dialog-title="dialogTitle"
      :dialogVisible.sync="thresholdDialogVisible"
      :width="width"
      @dialogClose="(data) => this.thresholdDialogVisible = data"
      @dialogShow="()=>{this.$refs.thresholdComp.listByDeviceId()}">
      <div slot="content" :style="{width:diaWidth,height:diaHeight}" style="min-height: 40vh;">
        <threshold-value-list :key="deviceInfo.id" ref="thresholdComp" :deviceInfo="deviceInfo" :form="form"></threshold-value-list>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import ModifyDevice from "./Modify";
import ThresholdValueList from "./ThresholdValueList.vue";
import DialogHeader from "@/components/device_details/comp/DialogHeader";
import DialogComponent from "@/components/DialogComponent";
import CloudedGlass from "@/components/style/CloudedGlass";
import {deleteDevice, modifyDevice} from '@/network/device-info';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";

export default {
  name: "DeviceShowCompTable",
  components: {CloudedGlass, DialogHeader, ModifyDevice, FunctionDialogComponent, ThresholdValueList, DialogComponent},
  data() {
    return {
      thresholdDialogVisible: false,
      dialogVisible: false,
      form: {},
      dialogTitle: '',
      diaWidth: "",
      diaHeight: "80vh",
      component: 'VisualEdit',
      dialogData: null,
      receiveData: null,
      showFooter: false,
      width: '80vw',
      tableHeight: 0,
      //  返回屏幕分辨率
      screenHeight: document.body.clientHeight,
    }
  },
  props: {
    deviceInfo: {
      type: [Array, Object],
      required: true
    },
    tableColumns: {
      type: [Array, Object],
      required: true
    },
    spaceInfoId: {},
    spaceValue: {},
    deviceShowBrand: {
      type: Boolean,
      default: () => true
    },
    deviceShowModel: {
      type: Boolean,
      default: () => true
    }
  },
  created() {
    if ( this.screenHeight >= 960 ) {
      this.tableHeight = this.screenHeight * 0.80
    } else if ( this.screenHeight < 960 ) {
      this.tableHeight = this.screenHeight * 0.75
    }
  },
  mounted() {
    this.screenHeight = document.body.clientHeight
    //屏幕尺寸变化就重新赋值
    window.onresize = () => {
      this.screenHeight = document.body.clientHeight
    }
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    showThresholdDialog(dialogTitle, componentName, showFooter, width, distinguish, deviceInfo) {
      this.dialogTitle = dialogTitle;
      this.showFooter = showFooter;
      this.width = width;
      this.dialogData = distinguish;
      this.thresholdDialogVisible = true;
      this.deviceInfo = deviceInfo;
    },
    showDialog(dialogTitle, componentName, showFooter, width, distinguish, deviceInfo) {
      this.dialogTitle = dialogTitle;
      this.showFooter = showFooter;
      this.width = width;
      this.dialogData = distinguish;
      this.component = () => import('@/views/basic_operations/device_management/device_manager/comp/' + componentName + '.vue');
      this.dialogVisible = true;
      this.deviceInfo = deviceInfo;
    },
    receive(data) {
      this.receiveData = data;
    },
    saveData() {
      if ( this.dialogData === 'visual' ) {
        this.deviceInfo.visualId = this.receiveData;
      } else if ( this.dialogData === 'device' ) {
        if ( !this.$stringIsNotNullAndEmpty(this.receiveData.name) ) {
          this.$message.error('请先填写设备名称');
          return;
        }
        this.deviceInfo.name = this.receiveData.name;
        this.deviceInfo.note = this.receiveData.note;
      } else if ( this.dialogData === 'belongs' ) {
        if ( this.receiveData == null || !this.receiveData.spaceId ) {
          this.$message.error('请选择变更的空间');
          return;
        }
      }
      this.modifyDevice();
    },
    modifyDevice() {
      modifyDevice(this.deviceInfo).then(res => {
        if ( res.code === 0 ) {
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
        this.dialogVisible = false;
        this.$emit('getDeviceList');
      })
    },
    // 获取选中的信息
    selectChange(val) {
      this.$emit('tableViewSelectChange',val)
    },
    deleteDevice(val) {
      const h = this.$createElement;
      this.$confirm("提示", {
        title: '提示',
        message: h('div', {class: 'tips'}, [
          h('div', '是否确认解除绑定设备：' + val.name),
          h('div', {class: 'information'}, '*解除绑定只影响通过空间维护和查看设备，不影响设备的历史数据和实时告警。')
        ]),
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if ( action === 'confirm' ) {
            deleteDevice(val.id).then(res => {
              if ( res.code === 0 ) {
                this.$message.success('删除成功');
                this.$emit('getDeviceList');
              } else {
                this.$message.error('删除失败');
              }
            });
          }
        }
      })
    }
  },
  watch: {
    dialogVisible() {
      if ( !this.dialogVisible ) {
        this.$refs.functionDialogComponent.$destroy()
      }
    },
    thresholdDialogVisible() {
      if ( !this.thresholdDialogVisible ) {
        this.$refs.thresholdComp.$destroy()
      }
    },
    //  监听屏幕大小变化
    screenHeight(val) {
      //改变table显示条数，自适应屏幕大小
      if ( val >= 960 ) {
        this.tableHeight = val * 0.80
      } else if ( val < 960 ) {
        this.tableHeight = val * 0.75
      }
    },
  }
}
</script>

<style scoped>
.device {
  margin: 10px 10px 10px 5px;
  width: 240px;
  height: 338px;
  background: rgba(0, 0, 0, 0);
}

.status {
  width: 20px;
  height: 2px;
  background: #07E6F8;
  opacity: 1;
}

.dotStatus {
  text-align: center;
  margin: 0 auto;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 1;
}

.status.alarm {
  background: #de3200;
}

.main {
  width: 178px;
  overflow: auto;
  margin: 30px 46px 10px 31px;
}

.name {
  width: 60px;
  height: 20px;
  font-size: 1.06rem;
  font-weight: bold;
  line-height: 20px;
  color: #299BFF;
  opacity: 1;
}

.logo {
  float: right;
}

.cross-line {
  width: 100%;
  margin: 10px 0 16px 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

.type, .brand, .model, .note {
  height: 22px;
  font-weight: 400;
  line-height: 19px;
  color: #89A0B8;
  opacity: 1;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.control div:not(.button) {
  display: flex;
}

.control .button {
  width: 100%;
  text-align: center;
  line-height: 24px;
  margin: 3px;
  height: 24px;
  background: rgba(41, 155, 255, 0.2);
  border-radius: 2px;
  font-size: 0.85rem;
}

.control .button:hover {
  background: rgba(41, 155, 255, 0.5);
  cursor: pointer;
}

.tips {

}

.green {
  background: #15DEB5;
}

.red {
  background: rgba(232, 86, 86, 1);
}

.information {
  font-size: 0.8rem;
  color: yellow;
  margin-top: 15px;
}
</style>
<style>
.popoverClass {
  background: #083966;
  border: 1px solid #083966;
  text-align: center;
  height: 80px;
  text-align: center;
  line-height: 50px;
}
</style>
